import { EEnvironments } from '@/constants/environments'

export default {
  // Environment
  NODE_ENV: import.meta.env.VITE_HOST_ENV || EEnvironments.Development,

  // Base API URL
  BASE_API_URL: import.meta.env.VITE_BASE_API_URL,

  // App version
  APP_VERSION: import.meta.env.VITE_APP_VERSION || '1.01.00',

  // Sentry
  SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,

  // Posthog
  PUBLIC_POSTHOG_KEY: import.meta.env.VITE_PUBLIC_POSTHOG_KEY,
  PUBLIC_POSTHOG_HOST: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
}
